var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { wireOrgCollapseControls } from '../definitions';
import { collectEditableNodes } from './collect';
import { DiagramEditor } from './DiagramEditor';
import { ensureEditableHitTargets, tagEdgeLayer } from './hitTargets';
/** Install draw.io-style editing on a diagram group. */
export function installDiagramEditor(app, root, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) { options = {}; }
    tagEdgeLayer(root);
    ensureEditableHitTargets(app, root);
    var editor = new DiagramEditor(app, root, options);
    try {
        for (var _c = __values(collectEditableNodes(root)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var node = _d.value;
            editor.wireNode(node);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    editor.wireEdges();
    // Org minimize/expand buttons (kept above hit targets)
    if (((_b = root.metadata) === null || _b === void 0 ? void 0 : _b.diagramType) === 'orgChart') {
        wireOrgCollapseControls(app, root);
    }
    root.metadata.diagramEditor = editor;
    return editor;
}
/** Remove diagram editor overlays and listeners. */
export function uninstallDiagramEditor(root) {
    var _a;
    var editor = (_a = root.metadata) === null || _a === void 0 ? void 0 : _a.diagramEditor;
    editor === null || editor === void 0 ? void 0 : editor.destroy();
    delete root.metadata.diagramEditor;
}
export { DiagramEditor } from './DiagramEditor';
export { normalizeDegrees, pointerAngleDegrees, rotatedCardCenter, setRotationAroundCenter, snapDegrees, } from './rotate';
